import * as types from '../types'

export default {
    state: {
        user: {},
        token: null,
        title: ''
    },
    mutations: {
        [types.LOGIN]: (state, data) => {
            localStorage.token = data;
            state.token = data;
        },
        [types.LOGOUT]: (state) => {
            localStorage.removeItem('token');
            state.token = null
        },
        [types.TITLE]: (state, data) => {
            state.title = data;
        }
    },
    getters: {
        // token: token => state.token,
        // user: user => state.user,
        // platform: platform => state.platform,
        // idk: idk => state.idk,
    },
    actions: {
    }
}